// Kopfbereich der Startseite: Header-Version 11 „Titelbild mit Wechsel“ aus
// ~/Projects/davidmedia-header-test/header (h11.html + titelszene.js, Stand 04.10.2026).
// Szene im Look der Titelbilder: Licht, Strahlen, Staub, schräges 3D-Panel, eine Vorlagen-Karte
// hebt sich nach dem Klick ab, das Panel wechselt alle 7,2 s das Werkzeug.
//
// Umbau gegenüber der Demo: Kartendaten kommen als Import statt fetch, nur das Layout „rechts“,
// und starteTitelSzene() gibt eine Aufräum-Funktion zurück (Render-Schleife, Listener, Timer),
// damit die React-Seite beim Verlassen nichts weiterlaufen lässt. Außerhalb des Bildes ruht sie.

import KARTEN from './karten.json';

export function starteTitelSzene(wurzel, { produkte }) {
  const bild = id => `/startseite/panel-hd/${id}.webp`;
  const W = 1280, H = 720;
  const html = s => { const d = document.createElement('div'); d.innerHTML = s.trim(); return d.firstElementChild; };
  let aus = false;
  const timer = new Set();
  const spaeter = (fn, ms) => { const id = setTimeout(() => { timer.delete(id); if (!aus) fn(); }, ms); timer.add(id); };

  const sz = html('<div class="tszene"></div>');
  sz.innerHTML = `<div class="ts-bg"></div><div class="ts-key"></div><div class="ts-boden"></div>
    <canvas class="ts-strahlen"></canvas><div class="ts-kamera"></div><canvas class="ts-staub"></canvas>
    <div class="ts-vignette"></div><div class="ts-korn"></div>`;
  wurzel.prepend(sz);
  const kamera = sz.querySelector('.ts-kamera'), strahlen = sz.querySelector('.ts-strahlen'), staubC = sz.querySelector('.ts-staub');
  [[78, 18, 120], [64, 62, 80], [90, 74, 150], [52, 22, 60]].forEach(([x, y, d]) =>
    sz.insertBefore(html(`<div class="ts-bokeh" style="left:${x}%; top:${y}%; width:${d}px; height:${d}px"></div>`), kamera));

  // Ausschnitt einer Vorlagen-Karte aus der Panel-Aufnahme
  const ausschnitt = (id, r) => {
    const [x, y, w, h] = r;
    return `background-image:url(${bild(id)}); background-size:${W / w * 100}% ${H / h * 100}%; background-position:${x / (W - w) * 100}% ${y / (H - h) * 100}%;`;
  };

  // ---------- Panel mit abgehobener Karte ----------
  let panel = null, held = null;
  function bauePanel() {
    panel = html('<div class="ts-panel"></div>');
    panel.innerHTML = `<div class="dick" style="transform:translateZ(-30px)"></div><div class="dick" style="transform:translateZ(-20px); background:#120c08"></div><div class="dick" style="transform:translateZ(-10px); background:#18110c"></div>
      <div class="flaeche"></div><div class="glanz"></div><div class="kante"></div>`;
    kamera.appendChild(panel);
    setzeProdukt(produkte[0], true);
  }
  function setzeProdukt(id, sofort) {
    const fl = panel.querySelector('.flaeche'), k = KARTEN[id];
    // Beim Wechsel immer die Karte an derselben Stelle nehmen, damit sie jedes Mal am selben Ort abhebt
    let idx = k.hero;
    const z = KARTEN[produkte[0]].rects[KARTEN[produkte[0]].hero], zx = z[0] + z[2] / 2, zy = z[1] + z[3] / 2;
    let bd = 1e9; k.rects.forEach((q, i) => { const d = Math.hypot(q[0] + q[2] / 2 - zx, q[1] + q[3] / 2 - zy); if (d < bd) { bd = d; idx = i; } });
    const r = k.rects[idx] || k.rects[0];
    const cx = (r[0] + r[2] / 2) / W * 100, cy = (r[1] + r[3] / 2) / H * 100;
    const neu = document.createElement('div');
    neu.className = 'wechsel' + (sofort ? '' : ' weg');
    neu.style.cssText = 'position:absolute; inset:0;';
    neu.innerHTML = `<img src="${bild(id)}" alt=""${sofort ? ' fetchpriority="high"' : ''}><img class="unscharf" src="${bild(id)}" alt="" style="--dof:radial-gradient(circle at ${cx}% ${cy}%, transparent 0 13%, #000 40%)">`;
    fl.appendChild(neu);
    if (!sofort) {
      requestAnimationFrame(() => requestAnimationFrame(() => neu.classList.remove('weg')));
      [...fl.children].slice(0, -1).forEach(alt => { alt.classList.add('weg'); spaeter(() => alt.remove(), 1000); });
    }
    // abgehobene Karte + Halo + Schatten
    if (held) Object.values(held).forEach(e => e.remove());
    const pos = `left:${r[0] / W * 100}%; top:${r[1] / H * 100}%; width:${r[2] / W * 100}%; height:${r[3] / H * 100}%;`;
    held = {
      schatten: html(`<div class="ts-schatten" style="left:${(r[0] + r[2] * .12) / W * 100}%; top:${(r[1] + r[3] * .3) / H * 100}%; width:${r[2] / W * 130}%; height:${r[3] / H * 120}%;"></div>`),
      halo: html(`<div class="ts-halo" style="left:${(r[0] - r[2] * .7) / W * 100}%; top:${(r[1] - r[3] * .6) / H * 100}%; width:${r[2] * 2.4 / W * 100}%; height:${r[3] * 2.2 / H * 100}%;"></div>`),
      karte: html(`<div class="ts-karte" style="${pos}"><div class="rahmen"></div><div class="bild" style="${ausschnitt(id, r)}"></div><div class="glanz2"></div>
        <svg class="ts-zeiger" viewBox="0 0 24 24" style="left:62%; top:58%; width:26%"><path d="M5 2.5l14 10.6-6.2 1.1-3.6 6.3z" fill="#fff" stroke="#111" stroke-width="1.3" stroke-linejoin="round"/></svg></div>`),
    };
    panel.append(held.schatten, held.halo, held.karte);
  }

  // ---------- Schwebende Karten (aus Panel-Aufnahmen) und Rauten ----------
  const schwebe = [];
  function schwebeKarte(id, idx, x, y, z, breite, hell, unschaerfe, klasse = '') {
    const r = KARTEN[id].rects[idx % KARTEN[id].rects.length];
    const el = html(`<div class="ts-schwebe ${klasse}" style="left:${x}%; top:${y}%; width:${breite}px; aspect-ratio:${r[2]}/${r[3]}; ${ausschnitt(id, r)} filter:blur(${unschaerfe}px) brightness(${hell});"></div>`);
    kamera.appendChild(el);
    schwebe.push({ el, z, phase: schwebe.length * 1.9, amp: 8 + schwebe.length % 3 * 4, rot: (schwebe.length % 2 ? -1 : 1) * (6 + schwebe.length * 2) });
  }
  function raute(x, y, z, groesse, unschaerfe) {
    const el = html(`<div class="ts-raute" style="left:${x}%; top:${y}%; width:${groesse}px; height:${groesse}px; filter:blur(${unschaerfe}px)"></div>`);
    kamera.appendChild(el);
    schwebe.push({ el, z, phase: schwebe.length * 2.3, amp: 12, rot: 45, raute: true });
  }

  // ---------- Strahlen und Staub (Canvas) ----------
  let staub = [];
  function zeichneStrahlen() {
    const w = strahlen.width = sz.clientWidth, h = strahlen.height = sz.clientHeight, c = strahlen.getContext('2d');
    c.clearRect(0, 0, w, h); c.globalCompositeOperation = 'lighter';
    const qx = w * 1.04, qy = -h * .28, ziel = Math.atan2(h * .95 - qy, w * .32 - qx);
    for (let i = 0; i < 8; i++) {
      const a = ziel + (i - 3.5) * .055 + Math.sin(i * 7.1) * .012, breite = .018 + (i * 37 % 10) / 400, laenge = Math.hypot(w, h) * (.9 + (i * 53 % 10) / 30);
      const g = c.createLinearGradient(qx, qy, qx + Math.cos(a) * laenge, qy + Math.sin(a) * laenge);
      const st = .55 + (i * 29 % 10) / 25;
      g.addColorStop(0, `rgba(255,150,70,${st})`); g.addColorStop(.45, `rgba(255,130,50,${st * .55})`); g.addColorStop(.75, 'rgba(255,120,40,0)');
      c.fillStyle = g; c.beginPath(); c.moveTo(qx, qy);
      c.lineTo(qx + Math.cos(a - breite) * laenge, qy + Math.sin(a - breite) * laenge);
      c.lineTo(qx + Math.cos(a + breite) * laenge, qy + Math.sin(a + breite) * laenge); c.closePath(); c.fill();
    }
    strahlen.style.filter = 'blur(14px)';
    // Staub nur im Lichtkegel, nahe der Quelle dichter
    staubC.width = w; staubC.height = h;
    staub = Array.from({ length: 170 }, (_, i) => {
      const d = Math.pow(((i * 0.618) % 1), 1.6) * .85 + .08, a = ziel + (((i * 0.37) % 1) - .5) * .42;
      const gross = i % 23 === 0;
      return { qx, qy, d, a, r: gross ? 2.6 + (i % 3) : .5 + (i % 5) * .3, al: gross ? .25 : .35 + (i % 7) / 14, v: .004 + (i % 9) / 3000, ph: i };
    });
    staub.L = Math.hypot(w, h);
  }
  function zeichneStaub(t) {
    const c = staubC.getContext('2d'); c.clearRect(0, 0, staubC.width, staubC.height);
    for (const p of staub) {
      const d = (p.d + t * p.v) % .95, x = p.qx + Math.cos(p.a) * d * staub.L + Math.sin(t * .6 + p.ph) * 6, y = p.qy + Math.sin(p.a) * d * staub.L + Math.cos(t * .5 + p.ph) * 4;
      const fade = Math.min(1, d * 6) * (1 - Math.max(0, (d - .6) / .35));
      c.fillStyle = `rgba(255,200,150,${(p.al * fade).toFixed(3)})`;
      c.beginPath(); c.arc(x, y, p.r, 0, Math.PI * 2); c.fill();
    }
  }

  // ---------- Aufbau (Layout „rechts“) ----------
  bauePanel();
  const id0 = produkte[0];
  schwebeKarte(id0, 9, 70, 70, 420, 230, 1.6, 11);   // groß, nah an der Kamera
  schwebeKarte(id0, 14, 90, 4, 320, 190, 1.5, 9);
  schwebeKarte(id0, 20, 40, 10, -650, 150, .55, 5, 'hinter-text');   // klein, weit hinten (Handy: läge hinter der Überschrift)
  raute(42, 74, 200, 26, 3); raute(60, 8, -300, 20, 4); raute(97, 44, 300, 34, 6); raute(52, 52, -100, 16, 1);
  zeichneStrahlen();
  // Strahlen hängen an der Größe der Szene (Handy: Text und Panel untereinander, andere Höhe)
  // Der Hub der Karte ist in px gebaut (für ein Panel ab ~920 px Breite = Fenster 1440). Auf kleineren
  // Panels flöge sie sonst aus dem Panel heraus, deshalb dort anteilig kleiner.
  let hubFaktor = 1;
  const messen = () => { hubFaktor = Math.min(1, panel.offsetWidth / 922); };
  messen();
  const ro = new ResizeObserver(() => { if (!aus) { zeichneStrahlen(); messen(); } });
  ro.observe(sz);

  // ---------- Bewegung ----------
  const ZYKLUS = 7.2;
  const easeOutBack = x => { const c1 = 1.5, c3 = c1 + 1; return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2); };
  const sm = (a, b, x) => { const t = Math.min(1, Math.max(0, (x - a) / (b - a))); return t * t * (3 - 2 * t); };
  let letzterZyklus = 0;
  function zeichne(t) {
    // langsamer Push-in mit leichtem Bogen
    const k = .5 - .5 * Math.cos(t * .16);
    kamera.style.transform = `scale(${1 + k * .035}) translate(${(-k * 1.2).toFixed(2)}%, ${(Math.sin(t * .16) * .5).toFixed(2)}%)`;
    const tz = t % ZYKLUS, zyklus = Math.floor(t / ZYKLUS);
    if (zyklus !== letzterZyklus) {
      letzterZyklus = zyklus;
      setzeProdukt(produkte[zyklus % produkte.length], false);
    }
    // Zeiger fährt hin, klickt, Karte hebt sich mit Überschwinger; Halo blendet dahinter auf
    const zeigerIn = sm(.2, 1.3, tz), klick = tz > 1.45 && tz < 1.6, hub = tz < 1.55 ? 0 : tz < 6.2 ? easeOutBack(Math.min(1, (tz - 1.55) / .8)) : 1 - sm(6.2, 7, tz);
    panel.style.transform = 'translate(0, -50%) rotateY(-32deg) rotateX(10deg) rotateZ(2deg)';
    held.karte.style.transform = `translateZ(${(hub * 170 * hubFaktor).toFixed(1)}px) rotateX(${(-hub * 14).toFixed(2)}deg) scale(${(1 + hub * .3).toFixed(3)})`;
    held.karte.querySelector('.rahmen').style.opacity = Math.min(1, hub * 1.2).toFixed(3);
    held.karte.querySelector('.glanz2').style.opacity = Math.min(1, hub).toFixed(3);
    held.halo.style.opacity = (Math.min(1, hub) * .95).toFixed(3); held.halo.style.transform = `translateZ(${(hub * 140 * hubFaktor).toFixed(1)}px)`;
    held.schatten.style.opacity = (Math.min(1, hub) * .85).toFixed(3); held.schatten.style.transform = 'translateZ(2px)';
    const zg = held.karte.querySelector('.ts-zeiger');
    zg.style.opacity = (zeigerIn * (1 - sm(5.6, 6.1, tz))).toFixed(3);
    zg.style.transform = `translate(${((1 - zeigerIn) * 160).toFixed(1)}%, ${((1 - zeigerIn) * 120).toFixed(1)}%) scale(${klick ? .82 : 1})`;
    for (const s of schwebe) {
      const dx = Math.sin(t * .35 + s.phase) * s.amp, dy = Math.cos(t * .28 + s.phase) * s.amp * .8;
      s.el.style.transform = `translate3d(${dx.toFixed(1)}px, ${dy.toFixed(1)}px, ${s.z}px) rotate(${s.raute ? 45 + Math.sin(t * .4 + s.phase) * 10 : Math.sin(t * .2 + s.phase) * 3 + s.rot * .3}deg)`;
    }
    zeichneStaub(t);
  }

  // Wer keine Bewegung möchte, bekommt das Standbild mit abgehobener Karte. Auf dem Handy ebenso:
  // dort ist das Panel ausgeblendet, und den Staub 60-mal pro Sekunde neu zu zeichnen ließ das Scrollen
  // ruckeln. Er steht still, die Bewegung kommt dort nur aus billigen CSS-Animationen (startseite.css).
  if (matchMedia('(prefers-reduced-motion: reduce), (max-width: 860px)').matches) {
    zeichne(3);
    return () => { aus = true; timer.forEach(id => clearTimeout(id)); timer.clear(); ro.disconnect(); sz.remove(); };
  }

  // Nur rechnen, solange der Kopfbereich zu sehen ist; die Zeit läuft beim Wiederkommen weiter
  let sichtbar = true, rafId = 0, zeit = 0, vorher = performance.now();
  const io = new IntersectionObserver(([e]) => {
    sichtbar = e.isIntersecting;
    if (sichtbar && !rafId) { vorher = performance.now(); rafId = requestAnimationFrame(lauf); }
  });
  io.observe(wurzel);
  function lauf(now) {
    rafId = 0;
    if (aus || !sichtbar) return;
    // rAF-Zeitstempel kann vor dem zuletzt gemessenen performance.now() liegen: nie rückwärts laufen
    zeit += Math.min(.1, Math.max(0, (now - vorher) / 1000)); vorher = Math.max(vorher, now);
    zeichne(zeit);
    rafId = requestAnimationFrame(lauf);
  }
  zeichne(0);
  rafId = requestAnimationFrame(lauf);

  return function stoppeTitelSzene() {
    aus = true;
    cancelAnimationFrame(rafId);
    timer.forEach(id => clearTimeout(id)); timer.clear();
    io.disconnect(); ro.disconnect();
    sz.remove();
  };
}
